import { Divider, Stack } from '@mui/material';

import { Text, api } from 'common';

import {
  BlockSelectField,
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const MedicationsVariant = {
  schema: PatientDataStore.MedicationsConfigSchema,
  Config: () => {
    const { setValue: setEncounters } = useSelectedNodeField('config.encounters');
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Medication Filters
        </Text>
        <ParentBlockSelectField
          fieldName="config.encounters.sourceBlockName"
          label="Encounters Source"
          helperText={getSourceBlockNameHelperText('encounters')}
          clearable
          onClear={() => setEncounters(undefined)}
        />
        <BlockSelectField
          fieldName="config.medicationFilters.status"
          label="Medication Status"
          options={PatientDataStore.MEDICATION_STATUS_OPTIONS.map((value) => ({
            label: value,
            value,
          }))}
        />
        <Divider sx={{ marginY: 2 }} />
        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
